import { render, staticRenderFns } from "./international_bicycle_shipping.vue?vue&type=template&id=868f9ec4&scoped=true&"
import script from "./international_bicycle_shipping.vue?vue&type=script&lang=ts&"
export * from "./international_bicycle_shipping.vue?vue&type=script&lang=ts&"
import style0 from "./international_bicycle_shipping.vue?vue&type=style&index=0&id=868f9ec4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f9ec4",
  null
  
)

export default component.exports